import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCommentCircleFilled = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 15.9998,
		cy: 16.0013,
		r: 13.8333,
		stroke: "#D9D9D9"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M10.0902 11.1111V11.1107C10.0902 10.7867 10.3526 10.5273 10.6668 10.5273H21.3335C21.6526 10.5273 21.9168 10.7916 21.9168 11.1107V19.1107C21.9168 19.4298 21.6526 19.694 21.3335 19.694H12.0002H11.6895L11.4698 19.9137L10.0845 21.299L10.0902 11.1111Z",
		stroke: "#162395",
		strokeWidth: 1.5
	})]
});
export default SvgCommentCircleFilled;
